import styled, { css } from "styled-components";
import { disabled, focusRing } from "@sproutsocial/seeds-react-mixins";
import Box from "@sproutsocial/seeds-react-box";
import { StyledSwitchButton as Switch } from "@sproutsocial/seeds-react-switch";
import type { TypeMenuItemContainerProps } from "./MenuTypes";

export const MenuItemContainer = styled(Box)<TypeMenuItemContainerProps>`
  ${(props) =>
    !props.hidden &&
    css`
      display: block;
    `};
  width: 100%;
  border-radius: ${(props) => props.theme.radii[500]};
  background-color: ${(props) => props.theme.colors.listItem.background.base};
  border: none;
  text-align: left;
  color: ${(props) => props.theme.colors.text.body};
  font-family: ${(props) => props.theme.fontFamily};
  font-weight: ${(props) => props.theme.fontWeights.normal};
  padding: ${(props) => `6px ${props.theme.space[300]}`};
  list-style-type: none;
  outline: 0;
  ${(props) => css`
    ${props.theme.typography[200]};
  `};

  ${(props) =>
    props.selected &&
    !props.isCheckboxOrRadio &&
    css`
      font-weight: ${(props) => props.theme.fontWeights.semibold};
    `}

  ${(props) =>
    props.active &&
    !props.disabled &&
    css`
      color: ${(props) => props.theme.colors.text.inverse};
      background-color: ${props.theme.colors.listItem.background.selected};

      .Icon-svg {
        color: ${(props) => props.theme.colors.text.inverse};
      }
    `}

  // Add border to Switches inside of active Menu Items so they do not disappear into the background.
   ${Switch} {
    ${(props) =>
      props.active &&
      !props.disabled &&
      css`
        border-color: ${(props) => props.theme.colors.container.border.base};
      `}
  }

  ${(props) =>
    !props.disabled &&
    css`
      &:focus,
      &:hover {
        color: ${(props) => props.theme.colors.text.body};
        background-color: ${(props) =>
          props.theme.colors.listItem.background.hover};

        .Icon-svg {
          color: unset;
        }
      }
    `}

  ${(props) =>
    props.interactive && !props.disabled
      ? css`
          &:hover {
            cursor: pointer;
          }
        `
      : css`
          &:hover {
            cursor: default;
          }
        `}
  ${(props) => props.disabled && disabled}
`;

export const MenuItemsContainer = styled(Box)`
  list-style-type: none;
  &:focus {
    ${focusRing}
  }
  & > div[role="group"]:first-of-type {
    border-top: none;
  }
`;
